import Dexie from 'dexie'

let Db = new Dexie("RefappWeb")

Db.version(1).stores({
	configs: 'key,value'
})

export default Db
